module.exports = __webpack_public_path__ + "no.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/no.svg
// module id = 990
// module chunks = 0